import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const Produits = lazy(() => import("../pages/produits/page"));
const ProduitDetail = lazy(() => import("../pages/produit/page"));
const Artisans = lazy(() => import("../pages/artisans/page"));
const ArtisanDetail = lazy(() => import("../pages/artisan/page"));
const Connexion = lazy(() => import("../pages/connexion/page"));
const CommentCaMarche = lazy(() => import("../pages/comment-ca-marche/page"));
const Panier = lazy(() => import("../pages/panier/page"));
const Commande = lazy(() => import("../pages/commande/page"));
const MesCommandes = lazy(() => import("../pages/mes-commandes/page"));
const MonProfil = lazy(() => import("../pages/mon-profil/page"));
const Notifications = lazy(() => import("../pages/notifications/page"));
const DashboardArtisan = lazy(() => import("../pages/dashboard-artisan/page"));
const DashboardAdmin = lazy(() => import("../pages/dashboard-admin/page"));
const Inscription = lazy(() => import("../pages/inscription/page"));
const MotDePasseOublie = lazy(() => import("../pages/mot-de-passe-oublie/page"));
const ReinitialiserMotDePasse = lazy(() => import("../pages/reinitialiser-mot-de-passe/page"));
const ConditionsUtilisation = lazy(() => import("../pages/conditions-dutilisation/page"));
const PolitiqueConfidentialite = lazy(() => import("../pages/politique-de-confidentialite/page"));
const VerificationOtp = lazy(() => import("../pages/verification-otp/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produits",
    element: <Produits />,
  },
  {
    path: "/produit/:slug",
    element: <ProduitDetail />,
  },
  {
    path: "/artisans",
    element: <Artisans />,
  },
  {
    path: "/artisan/:slug",
    element: <ArtisanDetail />,
  },
  {
    path: "/connexion",
    element: <Connexion />,
  },
  {
    path: "/comment-ca-marche",
    element: <CommentCaMarche />,
  },
  {
    path: "/panier",
    element: <Panier />,
  },
  {
    path: "/commande",
    element: <Commande />,
  },
  {
    path: "/mes-commandes",
    element: <MesCommandes />,
  },
  {
    path: "/mon-profil",
    element: <MonProfil />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/dashboard-artisan",
    element: <DashboardArtisan />,
  },
  {
    path: "/dashboard-admin",
    element: <DashboardAdmin />,
  },
  {
    path: "/inscription",
    element: <Inscription />,
  },
  {
    path: "/mot-de-passe-oublie",
    element: <MotDePasseOublie />,
  },
  {
    path: "/reinitialiser-mot-de-passe",
    element: <ReinitialiserMotDePasse />,
  },
  {
    path: "/conditions-dutilisation",
    element: <ConditionsUtilisation />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/verification-otp",
    element: <VerificationOtp />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
